/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.19.0
 * @since 1.19.0
 */

import { useSelector } from 'react-redux';

import { tableLabelsListSelector, tableLabelsUrlSelector } from '../../../selectors';

export const useTableLabels = () => {

    const labelsUrl = useSelector(tableLabelsUrlSelector);
    const options = useSelector(tableLabelsListSelector(labelsUrl));

    return {
        options,
    };
};
